import { adboardFragment as mapFragment } from "@/components/AnyReactComponent/MapMarker";
import { GraphQLTypes, InputType, Selector } from "@/generated/zeus";

export type PriceSummaryType={
    days: number;
    subtotal: number;
    pricePerDay: number;
    gst: number;
    discount?: number;
    totalRent: number;
}

export const adboardFragment = Selector('AdBoard')({
  ...mapFragment,
  workspaceId:true,
  acceptedMediaTypes:true,
  players:[{},{
    id:true,
    screenSize:{
      width:true,
      height:true 
    },
    resolution:{
      width:true,
      height:true
    },
    map:{
      lat:true,
      lng:true
    }
  }]
});

export type AdboardFragment = InputType<GraphQLTypes['AdBoard'], typeof adboardFragment>;